/** Read once: Android picker Files can fail when WebView later streams FormData. */
export async function prepareFileUpload(file: Blob): Promise<{
  bytes: ArrayBuffer;
  sha256: string;
}> {
  const bytes = await file.arrayBuffer();
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  const sha256 = Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, '0')).join('');
  return { bytes, sha256 };
}
